var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5796 17.3096C9.16985 17.3096 6.40625 20.0732 6.40625 23.483H18.7529C18.7529 20.0732 15.9893 17.3096 12.5796 17.3096Z",
    fill: "#08A98A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7845 23.483H17.7267V18.3385C17.7267 16.6121 16.8655 15.009 15.423 14.0511L14.1328 13.1941L15.423 12.337C16.8655 11.3791 17.7267 9.77611 17.7267 8.04963V2.90518H19.7845V8.04963C19.7845 10.0076 18.9933 11.8514 17.6207 13.1941C18.9933 14.5368 19.7845 16.3806 19.7845 18.3385V23.483Z",
    fill: "#08A98A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43669 23.483H5.37891V18.3385C5.37891 16.3806 6.17012 14.5368 7.54266 13.1941C6.17012 11.8514 5.37891 10.0076 5.37891 8.04963V2.90518H7.43669V8.04963C7.43669 9.77611 8.29787 11.3791 9.74037 12.337L11.0306 13.1941L9.74037 14.0511C8.29787 15.009 7.43669 16.6121 7.43669 18.3385V23.483Z",
    fill: "#08A98A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8403 1.87629H3.32031V3.93407H21.8403V1.87629Z",
    fill: "#08A98A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8403 22.4541H3.32031V24.5119H21.8403V22.4541Z",
    fill: "#08A98A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pendingIcon.99daa40111c857afb8f41c2cb676bf70.svg";
export { ForwardRef as ReactComponent };